import apiClient from "./apiClient";

export function listExpensesRequest(params = {}) {
  return apiClient.get("/expenses", { params });
}

export function getExpenseRequest(expenseId) {
  return apiClient.get(`/expenses/${expenseId}`);
}

function appendItemsToFormData(formData, items) {
  items.forEach((item, index) => {
    formData.append(`items[${index}][item_name]`, item.item_name);
    formData.append(`items[${index}][quantity]`, String(item.quantity));
    formData.append(`items[${index}][unit_price]`, String(item.unit_price));
    formData.append(`items[${index}][amount]`, String(item.amount));
  });
}

function buildExpenseFormData(payload, { files = [], removeReceiptIds = [] } = {}) {
  const formData = new FormData();

  Object.entries(payload).forEach(([key, value]) => {
    if (key === "items") return;
    if (value === null || value === undefined || value === "") return;
    formData.append(key, value);
  });

  if (Array.isArray(payload.items)) {
    appendItemsToFormData(formData, payload.items);
  }

  files.forEach((file) => {
    formData.append("receipts[]", file);
  });

  removeReceiptIds.forEach((id) => {
    formData.append("remove_receipt_ids[]", String(id));
  });

  return formData;
}

function shouldUseMultipart({ files, removeReceiptIds }) {
  return (files?.length ?? 0) > 0 || (removeReceiptIds?.length ?? 0) > 0;
}

const multipartConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

export function createExpenseRequest(payload, options = {}) {
  const { files = [], removeReceiptIds = [] } = options;
  if (shouldUseMultipart({ files, removeReceiptIds })) {
    return apiClient.post(
      "/expenses",
      buildExpenseFormData(payload, { files, removeReceiptIds }),
      multipartConfig,
    );
  }
  return apiClient.post("/expenses", payload);
}

export function updateExpenseRequest(expenseId, payload, options = {}) {
  const { files = [], removeReceiptIds = [] } = options;
  if (shouldUseMultipart({ files, removeReceiptIds })) {
    const formData = buildExpenseFormData(payload, { files, removeReceiptIds });
    formData.append("_method", "PATCH");
    return apiClient.post(`/expenses/${expenseId}`, formData, multipartConfig);
  }
  return apiClient.patch(`/expenses/${expenseId}`, payload);
}

export function deleteExpenseRequest(expenseId) {
  return apiClient.delete(`/expenses/${expenseId}`);
}
